import { IEnvironment } from './ienvironment';

const baseUrl = (window as any)['env']['backendBaseUrl'] || 'http://dev.hephaestus:5010'; // eslint-disable-line
const chatBaseUrl = (window as any)['env']['chatBaseUrl'] || 'ws://dev.hephaestus:8010'; // eslint-disable-line
const chatServiceUrl = `${chatBaseUrl.replace(/\/$/, '')}/api/v1`;

export const environment: IEnvironment = {
  production: true,
  logLevel: 'debug',
  toolServiceUrl: `${baseUrl}/api/v137`,
  chatServiceUrl,
};
